<template lang="pug">
.briq-form-element
  label {{ label }}
  briq-required-and-optional-markers(:isRequired="isRequired" :hideOptionalMarker="hideOptionalMarker" :label="label")
  briq-tooltip(:help="help")
  .check-buttons
    div(v-for="v in options")
      input.hidden-input(
        type="checkbox" 
        :id="optionId(v)"
        :checked="isSelected(v)"
        @change="e => toggle(e, v)"
        :disabled="disabled"
        )
      label.visual-button.type-bold(:for="optionId(v)") {{ optionLabel(v) }}
  button.toggle-all-button.mt-XXS(v-if="hideToggleAll !== true" @click="toggleAll" :data-test-id="generateTestId(`toggle-all-${label}`)") {{ toggleAllLabel }}
  .validation-message(v-if="error") {{ error }}
</template>

<script>
import { append, filter, pipe, map, includes, allPass } from 'ramda'
import toKebab from '@/helpers/toKebab.js'

export default {
  name: 'BriqCheckButtons',
  props: {
    value: Array,
    options: Array,
    label: String,
    hideOptionalMarker: {
      type: Boolean,
      default: false,
    },
    trackField: String,
    displayField: String,
    disabled: Boolean,
    error: String,
    help: String,
    hideToggleAll: {
      type: Boolean,
      default: false,
    },
    minimumSelected: Number,
  },
  computed: {
    toggleAllLabel() {
      return this.allAreChecked ? 'Select none' : 'Select all'
    },
    isRequired() {
      return this.$attrs.required || this.required
    },
    allAreChecked() {
      return pipe(map(includes), allPass)(this.options)(this.value)
    },
  },
  methods: {
    toggle(event, v) {
      const trackValue = this.getTrackValue(v)
      const isChecking = event.target.checked

      //prettier-ignore
      if (!isChecking && this.minimumSelected && this.minimumSelected > this.value.filter(x=>x !== trackValue).length){
        event.target.checked = true
        return
      }

      const change = isChecking ? append(trackValue) : filter(x => x !== trackValue)
      this.$emit('input', change(this.value), v)
    },
    toggleAll() {
      const output = this.allAreChecked ? [] : this.options
      this.$emit('input', output)
    },
    getTrackValue(v) {
      return this.trackField ? v[this.trackField] : v
    },
    isSelected(v) {
      return this.value.includes(this.getTrackValue(v))
    },
    optionLabel(v) {
      return this.displayField ? v[this.displayField] : v
    },
    optionId(v) {
      return `toggle-${this.optionLabel(v).toLowerCase()}`
    },
    generateTestId(value) {
      return toKebab(value)
    },
  },
}
</script>

<style scoped lang="stylus">
.check-buttons
  display flex
  flex-flow row wrap
  justify-content flex-start

.visual-button
  background white
  text-align center
  padding 2px 12px
  border solid 1px #e2e2e2
  border-radius 3px
  color #2c333a
  display flex
  align-items center
  cursor pointer
  margin 8px 8px 8px 0

.hidden-input
  opacity 0
  width 0
  height 0
  display block

  &:checked + .visual-button
    background #4e5a6a
    color #fff

.toggle-all-button
  text-decoration underline
  color #4e5a6a

.toggle-all-button:hover
  color black
</style>
